export default {
  props: {
    ariaLabel: {
      type: String,
      required: false,
    },
    btnVariant: {
      type: String,
      required: false,
      default: 'pink',
    },
    btnVariantDisabled: {
      type: String,
      required: false,
    },
    btnTextVariant: {
      type: String,
      required: false,
      default: null,
    },
    btnTextVariantHover: {
      type: String,
    },
    btnText: {
      type: String,
      required: false,
      default: 'Start',
    },
    btnVariantHover: {
      type: String,
      required: false,
      default: null,
    },
    btnOutlineColor: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hoverIn: false,
    };
  },

  methods: {
    handleHoverIn(e) {
      e.preventDefault();
      this.hoverIn = !!this.$slots['button-icon-hover'] && true;
    },
    handleHoverOut(e) {
      e.preventDefault();
      this.hoverIn = !!this.$slots['button-icon'] && false;
    },
    onBtnClick: function () {
      this.$emit('btnCallToAction');
    },
  },
  destroyed() {
    this.hoverIn = false;
  },
};
